import { render } from "./terms-and-conditions-footer.vue?vue&type=template&id=a7ae8ad4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__